import { createAction } from 'redux-actions';

export const clearGuests = createAction('CLEAR_GUESTS');

export const removeGuest = createAction('REMOVE_GUEST');

export const guestsOnChangePage = createAction('GUESTS_ON_CHANGE_PAGE');

export const guestsOnChangeOrder = createAction('GUESTS_ON_CHANGE_ORDER');

export const guestsOnChangeQuery = createAction('GUESTS_ON_CHANGE_QUERY');
